import {
  Avatar,
  Badge,
  Box,
  Card,
  Container,
  Group,
  Modal,
  Stack,
  Table,
  Text,
  ThemeIcon,
  Title,
} from "@mantine/core";
import { useDisclosure, useMediaQuery } from "@mantine/hooks";
import {
  IconCalendar,
  IconClock,
  IconCloud,
  IconCloudRain,
  IconCloudSnow,
  IconDroplet,
  IconMapPin,
  IconSun,
  IconTrophy,
  IconWind,
} from "@tabler/icons-react";
import { useEffect, useRef, useState } from "react";
import { repositoryPos, repositoryWeb } from "../../_base/_const/_constVar";
import { ChartModelPosModel } from "../../model/ChartModelPosModel";
import { MessageResponse } from "../../model/MessageResponse";
import ItemFluctuation from "../ConfigSystem/ItemFluctuation/ItemFluctuation";
import TetHoliday from "./Tet";
export interface RewardPost {
  id: string;
  title: string;
  imageUrl: string;
  url: string;
}
const HomeViewProd = () => {
  const isSmallScreen = useMediaQuery("(max-width: 768px)");
  const gridCellHeight = isSmallScreen ? "28vh" : "34vh"; // 2 hàng ~ 56-68vh toàn block
  const boxRef = useRef<HTMLDivElement>(null);
  const [boxHeight, setBoxHeight] = useState(0);

  useEffect(() => {
    const updateHeight = () => {
      if (boxRef.current) {
        const height = boxRef.current.clientHeight;
        setBoxHeight(height);
      }
    };

    updateHeight();

    // Cập nhật lại khi resize window
    window.addEventListener("resize", updateHeight);

    return () => {
      window.removeEventListener("resize", updateHeight);
    };
  }, []);

  const [openedChart, { open: openChart, close: closeChart }] =
    useDisclosure(false);

  // Countdown Timer State
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  // Calculate countdown to 1/1/2026
  useEffect(() => {
    const calculateTimeLeft = () => {
      const targetDate = new Date("2027-01-01T00:00:00").getTime();
      const now = new Date().getTime();
      const difference = targetDate - now;

      if (difference > 0) {
        const days = Math.floor(difference / (1000 * 60 * 60 * 24));
        const hours = Math.floor(
          (difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
        );
        const minutes = Math.floor(
          (difference % (1000 * 60 * 60)) / (1000 * 60),
        );
        const seconds = Math.floor((difference % (1000 * 60)) / 1000);

        setTimeLeft({ days, hours, minutes, seconds });
      } else {
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
      }
    };

    calculateTimeLeft();
    const timer = setInterval(calculateTimeLeft, 1000);

    return () => clearInterval(timer);
  }, []);

  // Data for featured employees
  const [dataSale, setDataSale] = useState<ChartModelPosModel | null>(null);
  // Thêm state cho bài viết khen thưởng
  const [rewardArticles, setRewardArticles] = useState<any[]>([]);
  const [articlesLoading, setArticlesLoading] = useState(true);
  // Hover state cho ảnh bài viết khen thưởng
  const [hoveredArticleIdx, setHoveredArticleIdx] = useState<number | null>(
    null,
  );
  // Hover state cho 3 ô banner lấy từ bài viết
  const [hoveredTileIdx, setHoveredTileIdx] = useState<number | null>(null);

  // Function để fetch bài viết khen thưởng
  const getRewardArticles = async () => {
    try {
      setArticlesLoading(true);
      const response = await repositoryWeb.get(
        `/api/v1/TblArticlePos/get-list?Skip=0&Take=10`,
      );

      if (response && response.success && response.data) {
        // Chỉ lấy bài viết có status == 1 (1 hoặc "1")
        const activeOnly = (response.data as any[]).filter((item: any) => {
          const s = item?.status ?? item?.Status;
          return s === 1 || s === "1";
        });

        // Sắp xếp theo ngày tạo mới nhất và lấy tối đa 10 bài
        const sortedArticles = activeOnly
          .sort(
            (a: any, b: any) =>
              new Date(
                b.createdDate || b.dateCreated || b.createDate,
              ).getTime() -
              new Date(
                a.createdDate || a.dateCreated || a.createDate,
              ).getTime(),
          )
          .slice(0, 10);

        setRewardArticles(sortedArticles);
      }
    } catch (error) {
      console.error("Error fetching reward articles:", error);
      setRewardArticles([]);
    } finally {
      setArticlesLoading(false);
    }
  };

  useEffect(() => {
    const getData = async () => {
      try {
        // Call cả 2 API cùng lúc
        const [saleResponse] = await Promise.all([
          repositoryPos.get<MessageResponse<ChartModelPosModel>>(
            "/api/v1/CreateSellItem/get-chart-sale",
          ),
          // getRewardArticles(), // Gọi function fetch bài viết
        ]);

        if (saleResponse && saleResponse.success) {
          setDataSale(saleResponse.data);
        }
      } catch (e) {
        console.error("Error fetching data:", e);
      }
    };
    getData();
  }, []);

  // Completion percentage from API
  const [completionPercentage, setCompletionPercentage] = useState<number>(70);
  useEffect(() => {
    const getCompletionPercentage = async () => {
      try {
        const fromDate = "2026-01-01"; // 1/1/2025
        const toDate = "2027-01-01"; // 1/1/2026

        const res = await repositoryPos.get<any>(
          `/api/v1/CreateSellItem/get-grow-up?fromDate=${fromDate}&toDate=${toDate}`,
        );

        console.log("API get-grow-up response:", res);

        if (res && res.success && typeof res.data === "number") {
          // Convert decimal to percentage (multiply by 100)
          const percentage = Math.round(res.data * 100);
          setCompletionPercentage(percentage);
          console.log("Raw decimal value:", res.data);
          console.log("Converted to percentage:", percentage + "%");
        } else if (res && res.data) {
          // In case the percentage is nested in the response data
          console.log("Raw API data:", res.data);
          if (typeof res.data.percentage === "number") {
            const percentage = Math.round(res.data.percentage * 100);
            setCompletionPercentage(percentage);
            console.log("Completion percentage:", percentage + "%");
          }
        }
      } catch (e) {
        console.error("Error fetching completion percentage:", e);
      }
    };
    getCompletionPercentage();
  }, []);

  const [currentTime, setCurrentTime] = useState(new Date());
  const [weatherData, setWeatherData] = useState<any>(null);
  const [weatherLoading, setWeatherLoading] = useState(true);

  // Update time every second
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  // Fetch weather data using Open-Meteo API (Free, no API key required)
  useEffect(() => {
    const fetchWeather = async () => {
      try {
        // Hanoi coordinates: 21.0285° N, 105.8542° E
        const HANOI_LAT = 21.0285;
        const HANOI_LON = 105.8542;

        // Open-Meteo API - completely free, no API key needed
        const response = await fetch(
          `https://api.open-meteo.com/v1/forecast?latitude=${HANOI_LAT}&longitude=${HANOI_LON}&current=temperature_2m,relative_humidity_2m,wind_speed_10m,weather_code&hourly=temperature_2m,relative_humidity_2m&timezone=Asia%2FHo_Chi_Minh`,
          {
            method: "GET",
            headers: {
              Accept: "application/json",
            },
            signal: AbortSignal.timeout(5000),
          },
        );

        if (response.ok) {
          const data = await response.json();
          console.log("✅ Open-Meteo API success:", data);

          // Transform Open-Meteo data to match our component structure
          const weatherCode = data.current.weather_code;
          const weatherDescription = getWeatherDescription(weatherCode);

          setWeatherData({
            main: {
              temp: Math.round(data.current.temperature_2m),
              humidity: data.current.relative_humidity_2m,
              wind_speed: data.current.wind_speed_10m,
            },
            weather: [
              {
                main: getWeatherMain(weatherCode),
                description: weatherDescription,
              },
            ],
            name: "Hà Nội",
          });
        } else {
          // Fallback to intelligent mock data
          console.warn("⚠️ Open-Meteo API failed:", response.status);

          const currentHour = new Date().getHours();
          let weatherType = "Clear";
          let temp = 28;
          let humidity = 65;

          if (currentHour >= 6 && currentHour < 12) {
            // Morning
            weatherType = "Clear";
            temp = 26;
            humidity = 70;
          } else if (currentHour >= 12 && currentHour < 18) {
            // Afternoon
            weatherType = "Clear";
            temp = 32;
            humidity = 60;
          } else if (currentHour >= 18 && currentHour < 22) {
            // Evening
            weatherType = "Clouds";
            temp = 28;
            humidity = 75;
          } else {
            // Night
            weatherType = "Clear";
            temp = 24;
            humidity = 80;
          }

          setWeatherData({
            main: {
              temp: temp,
              humidity: humidity,
              wind_speed: Math.random() * 15 + 5, // Random wind speed 5-20 km/h
            },
            weather: [
              {
                main: weatherType,
                description: weatherType === "Clear" ? "trời quang" : "có mây",
              },
            ],
            name: "Hà Nội",
          });
        }
      } catch (error) {
        console.error("❌ Weather API error:", error);
        // Final fallback
        setWeatherData({
          main: { temp: 28, humidity: 75 },
          weather: [{ main: "Clear", description: "trời quang" }],
          name: "Hà Nội",
        });
      } finally {
        setWeatherLoading(false);
      }
    };

    fetchWeather();
    // Update weather every 15 minutes (Open-Meteo has generous rate limits)
    const weatherTimer = setInterval(fetchWeather, 15 * 60 * 1000);
    return () => clearInterval(weatherTimer);
  }, []);

  // Helper function to convert weather code to description
  const getWeatherDescription = (code: number) => {
    const weatherCodes: { [key: number]: string } = {
      0: "trời quang",
      1: "chủ yếu quang",
      2: "mây rải rác",
      3: "nhiều mây",
      45: "sương mù",
      48: "sương mù đóng băng",
      51: "mưa phùn nhẹ",
      53: "mưa phùn vừa",
      55: "mưa phùn dày",
      61: "mưa nhẹ",
      63: "mưa vừa",
      65: "mưa to",
      71: "tuyết rơi nhẹ",
      73: "tuyết rơi vừa",
      75: "tuyết rơi to",
      77: "hạt tuyết",
      80: "mưa rào nhẹ",
      81: "mưa rào vừa",
      82: "mưa rào to",
      85: "tuyết rơi nhẹ",
      86: "tuyết rơi to",
      95: "dông",
      96: "dông có mưa đá",
      99: "dông có mưa đá to",
    };
    return weatherCodes[code] || "trời quang";
  };

  // Helper function to convert weather code to main weather type
  const getWeatherMain = (code: number) => {
    if (code === 0 || code === 1) return "Clear";
    if (code >= 2 && code <= 3) return "Clouds";
    if (code >= 45 && code <= 48) return "Fog";
    if (code >= 51 && code <= 67) return "Rain";
    if (code >= 71 && code <= 86) return "Snow";
    if (code >= 95 && code <= 99) return "Thunderstorm";
    return "Clear";
  };

  const formatTime = (date: Date) => {
    return date.toLocaleTimeString("vi-VN", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    });
  };

  const formatDate = (date: Date) => {
    return date.toLocaleDateString("vi-VN", {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  const getWeatherIcon = (weatherMain: string) => {
    switch (weatherMain.toLowerCase()) {
      case "clear":
        return <IconSun size={16} />;
      case "clouds":
        return <IconCloud size={16} />;
      case "rain":
        return <IconCloudRain size={16} />;
      case "snow":
        return <IconCloudSnow size={16} />;
      default:
        return <IconCloud size={16} />;
    }
  };

  const getWeatherColor = (weatherMain: string) => {
    switch (weatherMain.toLowerCase()) {
      case "clear":
        return "yellow";
      case "clouds":
        return "gray";
      case "rain":
        return "blue";
      case "snow":
        return "cyan";
      default:
        return "gray";
    }
  };

  // Banner images data
  const bannerImages = [
    "/images/anhbanner/banner1.png",
    "/images/anhbanner/banner2.png",
    "/images/anhbanner/banner3.png",
    // The 4th slot will be the employee chart
  ];

  // Fallback images if banner images don't exist
  const fallbackImages = [
    "https://via.placeholder.com/400x300/4dabf7/ffffff?text=Banner+1",
    "https://via.placeholder.com/400x300/51cf66/ffffff?text=Banner+2",
    "https://via.placeholder.com/400x300/ff922b/ffffff?text=Banner+3",
  ];

  return (
    <Box
      style={{
        backgroundColor: "#f8f9fa",
        minHeight: "100vh",
        position: "relative",
      }}
    >
      {/* <TetHoliday /> */}
      {/* 100 NGÀY CẦN ĐỊ Countdown Banner */}
      <Box
        style={{
          background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
          padding: "24px 32px",
          margin: "0",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <Box
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background:
              'url(\'data:image/svg+xml,%3Csvg width="60" height="60" viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg"%3E%3Cg fill="none" fill-rule="evenodd"%3E%3Cg fill="%23ffffff" fill-opacity="0.1"%3E%3Ccircle cx="30" cy="30" r="4"/%3E%3C/g%3E%3C/g%3E%3C/svg%3E\')',
            opacity: 0.3,
          }}
        />
        <Container size="xl" px={0} style={{ position: "relative", zIndex: 1 }}>
          <Stack gap="lg">
            <Group
              justify="space-between"
              align="flex-start"
              wrap={isSmallScreen ? "wrap" : "nowrap"}
            >
              <Group gap="lg" align="center">
                <Box
                  style={{
                    background: "rgba(255, 255, 255, 0.3)",
                    borderRadius: "8px",
                    padding: isSmallScreen ? "8px" : "12px",
                    backdropFilter: "blur(10px)",
                    border: "1px solid rgba(255, 255, 255, 0.2)",
                  }}
                >
                  <Box
                    style={{
                      width: isSmallScreen ? 24 : 32,
                      height: isSmallScreen ? 24 : 32,
                      position: "relative",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <svg
                      width={isSmallScreen ? 24 : 32}
                      height={isSmallScreen ? 24 : 32}
                      viewBox="0 0 32 32"
                      fill="none"
                    >
                      <circle
                        cx="16"
                        cy="16"
                        r="14"
                        stroke="white"
                        strokeWidth="2"
                        fill="none"
                      />
                      <circle
                        cx="16"
                        cy="16"
                        r="9"
                        stroke="white"
                        strokeWidth="1.5"
                        fill="none"
                      />
                      <circle cx="16" cy="16" r="4" fill="white" />
                      <circle
                        cx="16"
                        cy="16"
                        r="1.5"
                        fill="rgba(116, 75, 162, 1)"
                      />
                    </svg>
                  </Box>
                </Box>
                <Box>
                  <Text
                    size={isSmallScreen ? "lg" : "xl"}
                    fw={700}
                    c="white"
                    style={{
                      fontSize: isSmallScreen ? "20px" : "28px",
                      lineHeight: 1.2,
                    }}
                  >
                    CHIẾN DỊCH CÁN ĐÍCH DOANH SỐ 2027
                  </Text>
                  {/* <Text
                    size="sm"
                    c="rgba(255, 255, 255, 0.9)"
                    style={{ fontSize: isSmallScreen ? "12px" : "14px" }}
                  >
                    Chiến dịch cán đích doanh số 2027
                  </Text> */}
                </Box>
              </Group>
              {isSmallScreen && (
                <Box style={{ width: "100%", textAlign: "center" }}>
                  <Text
                    size="md"
                    fw={600}
                    c="white"
                    style={{ fontSize: "16px" }}
                  >
                    Đích đến: 1/1/2027
                  </Text>
                </Box>
              )}
            </Group>
            <Box style={{ textAlign: "center" }}>
              <Text
                size={isSmallScreen ? "md" : "lg"}
                fw={600}
                c="white"
                mb="xs"
                style={{ fontSize: isSmallScreen ? "14px" : "16px" }}
              >
                ⏰ Thời gian còn lại
              </Text>
              <Group gap={isSmallScreen ? "sm" : "md"} justify="center">
                <Box style={{ textAlign: "center" }}>
                  <Text
                    size="xl"
                    fw={700}
                    c="white"
                    style={{
                      fontSize: isSmallScreen ? "24px" : "32px",
                      lineHeight: 1,
                    }}
                  >
                    {timeLeft.days}
                  </Text>
                  <Text
                    size="xs"
                    c="rgba(255, 255, 255, 0.8)"
                    style={{ fontSize: isSmallScreen ? "10px" : "12px" }}
                  >
                    ngày
                  </Text>
                </Box>
                <Text
                  c="white"
                  style={{ fontSize: isSmallScreen ? "16px" : "24px" }}
                >
                  :
                </Text>
                <Box style={{ textAlign: "center" }}>
                  <Text
                    size="xl"
                    fw={700}
                    c="white"
                    style={{
                      fontSize: isSmallScreen ? "24px" : "32px",
                      lineHeight: 1,
                    }}
                  >
                    {timeLeft.hours}
                  </Text>
                  <Text
                    size="xs"
                    c="rgba(255, 255, 255, 0.8)"
                    style={{ fontSize: isSmallScreen ? "10px" : "12px" }}
                  >
                    giờ
                  </Text>
                </Box>
                <Text
                  c="white"
                  style={{ fontSize: isSmallScreen ? "16px" : "24px" }}
                >
                  :
                </Text>
                <Box style={{ textAlign: "center" }}>
                  <Text
                    size="xl"
                    fw={700}
                    c="white"
                    style={{
                      fontSize: isSmallScreen ? "24px" : "32px",
                      lineHeight: 1,
                    }}
                  >
                    {timeLeft.minutes}
                  </Text>
                  <Text
                    size="xs"
                    c="rgba(255, 255, 255, 0.8)"
                    style={{ fontSize: isSmallScreen ? "10px" : "12px" }}
                  >
                    phút
                  </Text>
                </Box>
                <Text
                  c="white"
                  style={{ fontSize: isSmallScreen ? "16px" : "24px" }}
                >
                  :
                </Text>
                <Box style={{ textAlign: "center" }}>
                  <Text
                    size="xl"
                    fw={700}
                    c="white"
                    style={{
                      fontSize: isSmallScreen ? "24px" : "32px",
                      lineHeight: 1,
                    }}
                  >
                    {timeLeft.seconds}
                  </Text>
                  <Text
                    size="xs"
                    c="rgba(255, 255, 255, 0.8)"
                    style={{ fontSize: isSmallScreen ? "10px" : "12px" }}
                  >
                    giây
                  </Text>
                </Box>
              </Group>
            </Box>
            {!isSmallScreen && (
              <Group justify="center">
                <Box style={{ minWidth: "300px" }}>
                  <Text
                    size="lg"
                    fw={600}
                    c="white"
                    mb="lg"
                    style={{ fontSize: "18px", textAlign: "center" }}
                  >
                    Đích đến: 1/1/2027
                  </Text>
                  <Group gap="xl" align="center" justify="center">
                    <Box
                      style={{
                        position: "relative",
                        width: "140px",
                        height: "140px",
                      }}
                    >
                      <svg
                        width="140"
                        height="140"
                        style={{ position: "absolute" }}
                      >
                        <circle
                          cx="70"
                          cy="70"
                          r="60"
                          stroke="rgba(255, 255, 255, 0.3)"
                          strokeWidth="8"
                          fill="transparent"
                        />
                        <circle
                          cx="70"
                          cy="70"
                          r="60"
                          stroke="#FFD700"
                          strokeWidth="8"
                          fill="transparent"
                          strokeDasharray="377"
                          strokeDashoffset={
                            377 * (1 - completionPercentage / 100)
                          }
                          strokeLinecap="round"
                          style={{
                            transform: "rotate(-90deg)",
                            transformOrigin: "70px 70px",
                            transition: "stroke-dashoffset 0.5s ease-in-out",
                            filter:
                              "drop-shadow(0 0 8px rgba(255, 215, 0, 0.5))",
                          }}
                        />
                      </svg>
                      <Box
                        style={{
                          position: "absolute",
                          top: "50%",
                          left: "50%",
                          transform: "translate(-50%, -50%)",
                          textAlign: "center",
                        }}
                      >
                        <Text
                          size="xl"
                          fw={900}
                          c="#FFD700"
                          style={{
                            fontSize: "42px",
                            lineHeight: 1,
                            textShadow: "0 2px 4px rgba(0,0,0,0.3)",
                          }}
                        >
                          {completionPercentage}%
                        </Text>
                        <Text
                          size="sm"
                          c="rgba(255, 255, 255, 0.8)"
                          style={{
                            fontSize: "16px",
                            marginTop: "4px",
                            fontWeight: 600,
                          }}
                        >
                          Hoàn thành
                        </Text>
                      </Box>
                    </Box>
                  </Group>
                </Box>
              </Group>
            )}
            {isSmallScreen && (
              <Group gap="xl" justify="center" align="center">
                <Box style={{ textAlign: "center" }}>
                  <Box
                    style={{
                      position: "relative",
                      width: "120px",
                      height: "120px",
                      margin: "0 auto 12px auto",
                    }}
                  >
                    <svg
                      width="120"
                      height="120"
                      style={{ position: "absolute" }}
                    >
                      <circle
                        cx="60"
                        cy="60"
                        r="50"
                        stroke="rgba(255, 255, 255, 0.3)"
                        strokeWidth="8"
                        fill="transparent"
                      />
                      <circle
                        cx="60"
                        cy="60"
                        r="50"
                        stroke="#FFD700"
                        strokeWidth="8"
                        fill="transparent"
                        strokeDasharray="314"
                        strokeDashoffset={
                          314 * (1 - completionPercentage / 100)
                        }
                        strokeLinecap="round"
                        style={{
                          transform: "rotate(-90deg)",
                          transformOrigin: "60px 60px",
                          transition: "stroke-dashoffset 0.5s ease-in-out",
                          filter: "drop-shadow(0 0 8px rgba(255, 215, 0, 0.5))",
                        }}
                      />
                    </svg>
                    <Box
                      style={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        textAlign: "center",
                      }}
                    >
                      <Text
                        size="xl"
                        fw={900}
                        c="#FFD700"
                        style={{
                          fontSize: "32px",
                          lineHeight: 1,
                          textShadow: "0 2px 4px rgba(0,0,0,0.3)",
                        }}
                      >
                        {completionPercentage}%
                      </Text>
                    </Box>
                  </Box>
                  <Text
                    size="lg"
                    c="rgba(255, 255, 255, 0.9)"
                    fw={700}
                    style={{ fontSize: "18px" }}
                  >
                    🎯 Hoàn thành mục tiêu
                  </Text>
                </Box>
              </Group>
            )}
          </Stack>
        </Container>
      </Box>

      {/* Main Banner Grid (2x2) - Full viewport height */}
      <Box style={{ padding: 0, margin: 0 }}>
        <Box
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gridTemplateRows: "1fr 1fr",
            gap: 8,
            width: "100%",
            height: "100vh",
          }}
        >
          {/* Top-left - Banner 1 */}
          <Box
            ref={boxRef}
            style={{
              overflow: "hidden",
              borderTopLeftRadius: 12,
            }}
          >
            <div
              style={{
                paddingLeft: "5px",
                width: "100%",
                height: gridCellHeight,
                objectFit: "cover",
              }}
            >
              <ItemFluctuation isHome={true} heightProps={boxHeight - 75} />
            </div>
          </Box>

          {/* Top-right - Bài viết mới nhất [0] */}
          <Box
            onMouseEnter={() => setHoveredTileIdx(0)}
            onMouseLeave={() => setHoveredTileIdx(null)}
            onClick={() => {
              const a = rewardArticles?.[0];
              const link = a?.url || a?.externalUrl;
              if (link) window.open(link, "_blank");
            }}
            style={{
              cursor: rewardArticles?.[0] ? "pointer" : "default",
              position: "relative",
              width: "100%",
              height: "100%",
              borderRadius: 8,
              overflow: "hidden",
              background: "#fff",
              border: "1px solid #e9ecef",
              boxShadow:
                hoveredTileIdx === 0
                  ? "0 10px 24px rgba(0,0,0,0.18)"
                  : "0 4px 12px rgba(0,0,0,0.08)",
              transition: "box-shadow 180ms ease, transform 180ms ease",
            }}
            role={rewardArticles?.[0] ? "button" : undefined}
            aria-label={rewardArticles?.[0]?.title || "Bài viết mới nhất"}
          >
            <img
              src={
                (rewardArticles?.[0]?.thumnail as string) ||
                "/images/placeholder_16x9.png"
              }
              alt={rewardArticles?.[0]?.title || "Bài viết mới nhất"}
              style={{
                position: "absolute",
                inset: 0,
                width: "100%",
                height: "100%",
                objectFit: "cover",
                transform: hoveredTileIdx === 0 ? "scale(1.03)" : "scale(1)",
                transition: "transform 200ms ease",
              }}
            />
            {/* Overlay title */}
            <Box
              style={{
                position: "absolute",
                inset: 0,
                display: "flex",
                alignItems: "flex-end",
                background:
                  hoveredTileIdx === 0
                    ? "linear-gradient(0deg, rgba(0,0,0,0.55), rgba(0,0,0,0.1))"
                    : "linear-gradient(0deg, rgba(0,0,0,0.35), rgba(0,0,0,0.05))",
                color: "#fff",
                padding: 12,
                transition: "background 180ms ease",
              }}
            >
              <Text size="sm" fw={600} lineClamp={2}>
                {rewardArticles?.[0]?.title || "Bài viết mới nhất"}
              </Text>
            </Box>
          </Box>

          {/* Bottom-left - Bài viết mới [1] */}
          <Box
            onMouseEnter={() => setHoveredTileIdx(1)}
            onMouseLeave={() => setHoveredTileIdx(null)}
            onClick={() => {
              const a = rewardArticles?.[1];
              const link = a?.url || a?.externalUrl;
              if (link) window.open(link, "_blank");
            }}
            style={{
              cursor: rewardArticles?.[1] ? "pointer" : "default",
              position: "relative",
              width: "100%",
              height: "100%",
              borderRadius: 8,
              overflow: "hidden",
              background: "#fff",
              border: "1px solid #e9ecef",
              boxShadow:
                hoveredTileIdx === 1
                  ? "0 10px 24px rgba(0,0,0,0.18)"
                  : "0 4px 12px rgba(0,0,0,0.08)",
              transition: "box-shadow 180ms ease, transform 180ms ease",
            }}
            role={rewardArticles?.[1] ? "button" : undefined}
            aria-label={rewardArticles?.[1]?.title || "Bài viết"}
          >
            <img
              src={
                (rewardArticles?.[1]?.thumnail as string) ||
                "/images/placeholder_16x9.png"
              }
              alt={rewardArticles?.[1]?.title || "Bài viết"}
              style={{
                position: "absolute",
                inset: 0,
                width: "100%",
                height: "100%",
                objectFit: "cover",
                transform: hoveredTileIdx === 1 ? "scale(1.03)" : "scale(1)",
                transition: "transform 200ms ease",
              }}
            />
            <Box
              style={{
                position: "absolute",
                inset: 0,
                display: "flex",
                alignItems: "flex-end",
                background:
                  hoveredTileIdx === 1
                    ? "linear-gradient(0deg, rgba(0,0,0,0.55), rgba(0,0,0,0.1))"
                    : "linear-gradient(0deg, rgba(0,0,0,0.35), rgba(0,0,0,0.05))",
                color: "#fff",
                padding: 12,
                transition: "background 180ms ease",
              }}
            >
              <Text size="sm" fw={600} lineClamp={2}>
                {rewardArticles?.[1]?.title || "Bài viết"}
              </Text>
            </Box>
          </Box>

          {/* Bottom-right - Bài viết mới [2] */}
          <Box
            onMouseEnter={() => setHoveredTileIdx(2)}
            onMouseLeave={() => setHoveredTileIdx(null)}
            onClick={() => {
              const a = rewardArticles?.[2];
              const link = a?.url || a?.externalUrl;
              if (link) window.open(link, "_blank");
            }}
            style={{
              cursor: rewardArticles?.[2] ? "pointer" : "default",
              position: "relative",
              width: "100%",
              height: "100%",
              borderRadius: 8,
              overflow: "hidden",
              background: "#fff",
              border: "1px solid #e9ecef",
              boxShadow:
                hoveredTileIdx === 2
                  ? "0 10px 24px rgba(0,0,0,0.18)"
                  : "0 4px 12px rgba(0,0,0,0.08)",
              transition: "box-shadow 180ms ease, transform 180ms ease",
            }}
            role={rewardArticles?.[2] ? "button" : undefined}
            aria-label={rewardArticles?.[2]?.title || "Bài viết"}
          >
            <img
              src={
                (rewardArticles?.[2]?.thumnail as string) ||
                "/images/placeholder_16x9.png"
              }
              alt={rewardArticles?.[2]?.title || "Bài viết"}
              style={{
                position: "absolute",
                inset: 0,
                width: "100%",
                height: "100%",
                objectFit: "cover",
                transform: hoveredTileIdx === 2 ? "scale(1.03)" : "scale(1)",
                transition: "transform 200ms ease",
              }}
            />
            <Box
              style={{
                position: "absolute",
                inset: 0,
                display: "flex",
                alignItems: "flex-end",
                background:
                  hoveredTileIdx === 2
                    ? "linear-gradient(0deg, rgba(0,0,0,0.55), rgba(0,0,0,0.1))"
                    : "linear-gradient(0deg, rgba(0,0,0,0.35), rgba(0,0,0,0.05))",
                color: "#fff",
                padding: 12,
                transition: "background 180ms ease",
              }}
            >
              <Text size="sm" fw={600} lineClamp={2}>
                {rewardArticles?.[2]?.title || "Bài viết"}
              </Text>
            </Box>
          </Box>
        </Box>
      </Box>

      {/* Clock & Weather Widget - Fixed Position */}
      <Box
        style={{
          position: "fixed",
          top: "10px",
          right: "10px",
          zIndex: 1000,
          background:
            "linear-gradient(135deg, rgba(255,255,255,0.98) 0%, rgba(248,249,250,0.98) 100%)",
          backdropFilter: "blur(15px)",
          borderRadius: "12px",
          padding: "12px 16px",
          boxShadow: "0 8px 24px rgba(0,0,0,0.15), 0 2px 8px rgba(0,0,0,0.1)",
          border: "1px solid rgba(0,0,0,0.1)",
          minWidth: "280px",
          maxWidth: "320px",
          display: "none",
        }}
        className="sm:block"
      >
        <Stack gap="sm">
          {/* Time */}
          <Group gap="md" align="center">
            <ThemeIcon size="md" variant="light" color="blue">
              <IconClock size={18} />
            </ThemeIcon>
            <Text size="md" fw={700} c="blue">
              {formatTime(currentTime)}
            </Text>
          </Group>

          {/* Date */}
          <Group gap="md" align="center">
            <ThemeIcon size="md" variant="light" color="green">
              <IconCalendar size={18} />
            </ThemeIcon>
            <Text size="sm" fw={600} c="dimmed" style={{ lineHeight: 1.3 }}>
              {formatDate(currentTime)}
            </Text>
          </Group>

          {/* Weather */}
          {!weatherLoading && weatherData && (
            <>
              <Box
                style={{
                  height: "1px",
                  backgroundColor: "#e9ecef",
                  margin: "4px 0",
                }}
              />
              <Group gap="sm" align="center">
                <ThemeIcon
                  size="sm"
                  variant="light"
                  color={getWeatherColor(weatherData.weather[0].main)}
                >
                  {getWeatherIcon(weatherData.weather[0].main)}
                </ThemeIcon>
                <Stack gap={2} style={{ flex: 1 }}>
                  <Group gap="xs" align="center">
                    <Text size="sm" fw={600} c="dark">
                      {Math.round(weatherData.main.temp)}°C
                    </Text>
                    <Text size="xs" c="dimmed">
                      {weatherData.weather[0].description}
                    </Text>
                  </Group>
                  <Group gap="md">
                    <Group gap={4} align="center">
                      <IconDroplet size={12} color="blue" />
                      <Text size="xs" c="dimmed">
                        {weatherData.main.humidity}%
                      </Text>
                    </Group>
                    <Group gap={4} align="center">
                      <IconWind size={12} color="green" />
                      <Text size="xs" c="dimmed">
                        {Math.round(weatherData.main.wind_speed)} km/h
                      </Text>
                    </Group>
                    <Group gap={4} align="center">
                      <IconMapPin size={12} color="red" />
                      <Text size="xs" c="dimmed">
                        {weatherData.name}
                      </Text>
                    </Group>
                  </Group>
                </Stack>
              </Group>
            </>
          )}
        </Stack>
      </Box>

      {/* Hoạt động nội bộ nổi bật */}
      <Box style={{ padding: isSmallScreen ? 12 : 24 }}>
        <Container size={"100%"} px={0}>
          <Title order={2} size="h3" fw={700} c="#2c3e50" mb="md">
            Hoạt động nội bộ nổi bật:
          </Title>
          <Box
            style={{
              display: "grid",
              gridTemplateColumns: isSmallScreen ? "1fr" : "1fr 1fr",
              gap: 16,
              alignItems: "start",
            }}
          >
            {/* Left large item */}
            <Box>
              <Box
                onClick={() =>
                  window.open(
                    "https://drive.google.com/drive/folders/1x1YDVK2qvJ2pn9COx5ktcM7BZP7UQaRO",
                    "_blank",
                  )
                }
                style={{
                  cursor: "pointer",
                  borderRadius: 12,
                  overflow: "hidden",
                  backgroundImage: "url('/images/img_.png')",
                }}
              >
                <Box
                  style={{
                    width: "100%",
                    height: isSmallScreen ? 300 : 734,
                    borderRadius: 12,
                    overflow: "hidden",
                  }}
                >
                  <img
                    src="/images/img_standee_l_m_m_t.png"
                    alt="Employee achievement standee"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      display: "block",
                    }}
                  />
                </Box>
              </Box>
              <Text mt="xs" size="lg" fw={600}>
                Tại sao "Làm mát thần tốc" được yêu thích?
              </Text>
            </Box>

            {/* Right column stacked */}
            <Box
              style={{ display: "grid", gridTemplateRows: "1fr 1fr", gap: 16 }}
            >
              {/* Top item */}
              <Box>
                <Box
                  onClick={() =>
                    window.open(
                      "https://www.facebook.com/groups/521514798021434/posts/3001212356718320",
                      "_blank",
                    )
                  }
                  style={{
                    cursor: "pointer",
                    borderRadius: 12,
                    overflow: "hidden",
                    position: "relative",
                    backgroundImage: "url('/images/img_0x0.png')",
                    width: "100%",
                    height: isSmallScreen ? 200 : 316,
                  }}
                >
                  <img
                    src="/images/img_img_1186_1.png"
                    alt="Star employees July 2025"
                    style={{
                      position: "absolute",
                      inset: 0,
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                  <img
                    src="/images/img_banner_detail_ngang_pos.png"
                    alt="Employee recognition banner"
                    style={{
                      position: "absolute",
                      inset: 0,
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                </Box>
                <Text mt="xs" size="lg" fw={600}>
                  Những Ngôi Sao Sáng Tháng 7/2025
                </Text>
              </Box>

              {/* Bottom item */}
              <Box>
                <Box
                  onClick={() =>
                    window.open(
                      "https://www.facebook.com/61561398747000/videos/1303303978464385/?idorvanity=521514798021434",
                      "_blank",
                    )
                  }
                  style={{
                    cursor: "pointer",
                    borderRadius: 12,
                    overflow: "hidden",
                    backgroundImage: "url('/images/img_1.png')",
                    width: "100%",
                    height: isSmallScreen ? 200 : 316,
                  }}
                >
                  <img
                    src="/images/img_banner_website_pos.png"
                    alt="First workshop at Good Service"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                </Box>
                <Text mt="xs" size="lg" fw={600}>
                  Workshop đầu tiên tại Dịch Vụ Tốt
                </Text>
              </Box>
            </Box>
          </Box>
        </Container>
      </Box>

      {/* Tin tức khác - giữ nguyên URL ảnh theo code mẫu (không hiển thị link text) */}
      <Box style={{ padding: isSmallScreen ? 12 : 24 }}>
        <Container size={"100%"} px={0}>
          <Title order={2} size="h3" fw={700} c="#2c3e50" mb="md">
            Tin tức khác:
          </Title>
          <Box
            style={{
              display: "grid",
              gridTemplateColumns: isSmallScreen ? "1fr" : "1fr 1fr 1fr",
              gap: 16,
            }}
          >
            {/* News 1 */}
            <Box>
              <Box
                onClick={() =>
                  window.open(
                    "https://www.facebook.com/61561398747000/videos/1387881155743453?idorvanity=521514798021434",
                    "_blank",
                  )
                }
                style={{
                  cursor: "pointer",
                  borderRadius: 12,
                  overflow: "hidden",
                  position: "relative",
                }}
              >
                <img
                  src="/images/img_banner_website_b_i.png"
                  alt="Tin tức 1"
                  style={{
                    width: "100%",
                    height: isSmallScreen ? 200 : 240,
                    objectFit: "cover",
                    display: "block",
                  }}
                />
              </Box>
            </Box>

            {/* News 2 */}
            <Box>
              <Box
                onClick={() =>
                  window.open(
                    "https://www.facebook.com/61561398747000/videos/2622784644721554?idorvanity=521514798021434",
                    "_blank",
                  )
                }
                style={{
                  cursor: "pointer",
                  borderRadius: 12,
                  overflow: "hidden",
                }}
              >
                <img
                  src="/images/img_banner_website_b_i_1.png"
                  alt="Tin tức 2"
                  style={{
                    width: "100%",
                    height: isSmallScreen ? 200 : 240,
                    objectFit: "cover",
                    display: "block",
                  }}
                />
              </Box>
            </Box>

            {/* News 3 */}
            <Box>
              <Box
                onClick={() =>
                  window.open(
                    "https://www.facebook.com/61561398747000/videos/2622784644721554?idorvanity=521514798021434",
                    "_blank",
                  )
                }
                style={{
                  cursor: "pointer",
                  borderRadius: 12,
                  overflow: "hidden",
                }}
              >
                <img
                  src="/images/img_image.png"
                  alt="Tin tức 3"
                  style={{
                    width: "100%",
                    height: isSmallScreen ? 200 : 240,
                    objectFit: "cover",
                    display: "block",
                  }}
                />
              </Box>
            </Box>
          </Box>
        </Container>
      </Box>

      {/* Kickoff Banner - đặt dưới mục Tin tức khác */}
      <Box
        style={{
          padding: isSmallScreen ? "8px 12px 16px 12px" : "0 16px 24px 16px",
        }}
      >
        <Box
          style={{
            width: "100%",
            borderRadius: 16,
            overflow: "hidden",
            cursor: "pointer",
            transition: "transform 200ms ease",
          }}
          onMouseEnter={(e) =>
            (e.currentTarget.style.transform = "scale(1.02)")
          }
          onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
          onClick={() =>
            window.open(
              "https://www.facebook.com/groups/hacom.group/posts/3033043753535180",
              "_blank",
            )
          }
        >
          {/* <img
            src="/images/anhbanner/kichoff.jpg"
            alt="Kickoff 2025"
            style={{
              width: "100%",
              height: "auto",
              display: "block",
            }}
            onError={(e) => {
              e.currentTarget.src =
                "https://via.placeholder.com/1600x500/667eea/ffffff?text=KICKOFF+2025";
            }}
          /> */}
        </Box>
      </Box>

      {/* Kênh truyền thông nội bộ */}
      <Box style={{ padding: isSmallScreen ? 12 : 24 }}>
        <Container size={"100%"} px={0}>
          <Title order={3} fw={700} c="#2c3e50" mb={isSmallScreen ? 8 : 12}>
            Kênh truyền thông nội bộ:
          </Title>
          <Group align="center" gap={isSmallScreen ? 12 : 16}>
            <Box
              onClick={() =>
                window.open(
                  "https://www.facebook.com/groups/hacom.group",
                  "_blank",
                )
              }
              style={{
                width: isSmallScreen ? 36 : 48,
                height: isSmallScreen ? 30 : 40,
                cursor: "pointer",
              }}
              title="Mở nhóm Facebook HACOM"
              role="button"
            >
              <img
                src="/images/img_social_icons.svg"
                alt="Kênh truyền thông nội bộ"
                style={{ width: "100%", height: "100%", objectFit: "contain" }}
              />
            </Box>
            <Text size={isSmallScreen ? "xs" : "sm"} c="dimmed">
              (Link: https://www.facebook.com/groups/hacom.group)
            </Text>
          </Group>
        </Container>
      </Box>

      {/* Popup: Nhân viên xuất sắc (biểu đồ/bảng) */}
      <Modal
        opened={openedChart}
        onClose={closeChart}
        title="Nhân viên xuất sắc"
        size="lg"
        centered
      >
        <Table highlightOnHover>
          <Table.Thead>
            <Table.Tr>
              <Table.Th>Tên nhân viên</Table.Th>
              <Table.Th>Phòng ban</Table.Th>
              <Table.Th>Xếp hạng</Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {dataSale?.employeeList?.length ? (
              dataSale.employeeList
                .filter(
                  (e) =>
                    (e.employeeName || "").toLowerCase() !==
                    "nguyễn mạnh điệp".toLowerCase(),
                )
                .map((employee, index) => (
                  <Table.Tr key={index}>
                    <Table.Td>
                      <Group gap="sm">
                        <Avatar color="blue" radius="xl" size="sm">
                          {employee.employeeName
                            ?.split(" ")
                            .map((n: string) => n[0])
                            .join("")}
                        </Avatar>
                        <Text fw={500}>{employee.employeeName}</Text>
                      </Group>
                    </Table.Td>
                    <Table.Td>
                      <Text fw={600} c="green">
                        {employee.warehouseName}
                      </Text>
                    </Table.Td>
                    <Table.Td>
                      <Badge variant="light">#{index + 1}</Badge>
                    </Table.Td>
                  </Table.Tr>
                ))
            ) : (
              <Table.Tr>
                <Table.Td colSpan={3}>
                  <Text ta="center" c="dimmed">
                    Không có dữ liệu
                  </Text>
                </Table.Td>
              </Table.Tr>
            )}
          </Table.Tbody>
        </Table>
      </Modal>

      {/* Featured Employee Section removed (hiển thị qua popup) */}
    </Box>
  );
};

export default HomeViewProd;
